/**
 * YouTube URL helpers. Previously duplicated across the video card, the video
 * detail page and each SPA's copy of it — the redesign needs the raw video id
 * (for the IFrame player that reports progress), so all four callers share
 * these.
 */

const PLACEHOLDER_THUMBNAIL =
    'https://images.unsplash.com/photo-1599496336901-2b36a83637e6?q=80&w=2670&auto=format&fit=crop';

/** Matches the id in watch?v=, youtu.be/, /embed/ and /v/ forms. */
const YOUTUBE_ID_PATTERN = /^.*(youtu\.be\/|\/v\/|\/u\/\w\/|\/embed\/|watch\?v=|&v=)([^#&?]*).*/;

const YOUTUBE_ID_LENGTH = 11;

export function youTubeVideoId(url: string): string | null {
    if (!url) return null;
    const match = url.match(YOUTUBE_ID_PATTERN);
    const id = match?.[2];
    return id && id.length === YOUTUBE_ID_LENGTH ? id : null;
}

export function youTubeEmbedUrl(url: string): string | null {
    const id = youTubeVideoId(url);
    return id ? `https://www.youtube.com/embed/${id}` : null;
}

export function youTubeThumbnail(url: string): string {
    const id = youTubeVideoId(url);
    return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : PLACEHOLDER_THUMBNAIL;
}
